<template>
  <div>
    <!-- FILTROS -->
    <div class="card">
      <div class="card-header">
        <h5 class="card-title" id="accordion">Filtrar lances</h5>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">
              <label>Leilão id</label>
              <input @keyup="buscarlances" class="form-control" v-model="leilao_id" />
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label>Lote id</label>
              <input @keyup="buscarlances" class="form-control" v-model="lote_id" />
            </div>
          </div>
        </div>

        <button type="button" class="btn btn-primary" @click="buscarlances">Buscar</button>
        <button type="button" class="btn btn-default" @click="limparFiltros" style="margin-left: 5px">Limpar filtros</button>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <button type="button" class="btn btn-primary" @click="verificarResetarLances()">Resetar todos os lances</button>
      </div>
    </div>

    <!-- TABELA DE PROCESSO-->
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">Lances</h3>
        <div class="card-tools">
          <!-- PAGINAÇÃO  -->
          <ul class="pagination pagination-sm m-0 float-right">
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

            <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
              <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
                {{ pagina }}
              </a>
            </li>

            <li class="page-item">
              <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
            </li>
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
          </ul>
        </div>
      </div>

      <div class="card-body table-responsive p-0">
        <table class="table table-hover">
          <thead>
            <tr>
              <th>Seq</th>
              <th>Leilão</th>
              <th>Lote</th>
              <th>Data/hora</th>
              <th>Praça</th>
              <th>Valor</th>
              <th>Parcelado</th>
              <th>Apelido</th>
              <th>Nome</th>
              <th>Preferencial</th>
              <th>Nível</th>
              <th>IP</th>
              <th>Cancelado</th>
              <th>Motivo cancelamento</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(lance, index) in lances" :key="lance">
              <td>{{ index + 1 }}</td>
              <td>
                <a :href="'/admin/leilao/' + lance.leilao_id">{{ lance.leilao_id }} - {{ getFormatedTitle(lance.leilao_titulo) }}</a>
              </td>
              <td>
                <a :href="'/admin/leilao/' + lance.leilao_id + '/lotes/editar/' + lance.lote_id">
                  {{ lance.lote_numero }} - {{ getFormatedTitle(lance.lote_titulo) }}
                </a>
              </td>
              <td>{{ formatDate(lance.created_at) }}</td>
              <td>{{ lance.praca }}</td>
              <td>R$ {{ toCurrency(lance.valor) }}</td>
              <td>
                <p v-if="lance.parcelado && lance.parcelado == 1">Sim</p>
                <p v-else>Não</p>
              </td>
              <td>
                <a :href="'/admin/cadastros/detalhes/' + lance.lote_lance_user_id">{{ lance.apelido }}</a>
              </td>
              <td>
                <a :href="'/admin/cadastros/detalhes/' + lance.lote_lance_user_id">{{ lance.nome_completo }}</a>
              </td>

              <td>
                <p v-if="lance.igualar_lance && lance.igualar_lance == 1">Sim</p>
                <p v-else>Não</p>
              </td>
              <td>
                <p v-if="lance.nivel_preferencia">{{ lance.nivel_preferencia }}</p>
                <p v-else>0</p>
              </td>
              <td>{{ lance.ip }}</td>
              <td>
                <p v-if="lance.cancelado && lance.cancelado == 1">Sim</p>
                <p v-else>Não</p>
              </td>
              <td>{{ lance.motivo_cancelamento }}</td>

              <td>
                <a
                  id="navbarDropdown"
                  class="nav-link"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  v-pre
                >
                  <i class="fa-solid fa-bars" style="color: gray"></i>
                </a>

                <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right" aria-labelledby="navbarDropdown" ref="menu">
                  <div class="dropdown-divider"></div>
                  <a
                    style="cursor: pointer"
                    class="dropdown-item"
                    data-toggle="modal"
                    data-target="#cancelar-lance-modal"
                    @click="lance_selecionado = lance"
                  >
                    <i class="fa-solid fa-x"></i>
                    &nbsp;&nbsp; Cancelar
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer clearfix">
        <!-- TOTAIS  -->
        <div style="font-size: 13px" class="float-left" aria-live="polite">
          Exibindo do {{ inicio + 1 }} ao {{ inicio + lances.length }}
          <p>Total {{ total }}</p>
        </div>

        <p class="card-title" style="font-size: 12px; color: black; margin-right: 5px; margin-left: 10px">Por página</p>

        <select @change="alterarQtdPagina()" class="float-left card-titlecustom-select rounded-0" style="font-size: 12px" v-model="qtd_por_pagina">
          <option :value="25">25</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
          <option :value="200">200</option>
        </select>

        <div class="card-tools">
          <div class="input-group input-group-sm" style="width: 150px"></div>
        </div>

        <!-- PAGINAÇÃO  -->
        <ul class="pagination pagination-sm m-0 float-right">
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

          <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
            <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
              {{ pagina }}
            </a>
          </li>

          <li class="page-item">
            <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
          </li>
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
        </ul>
      </div>
    </div>

    <!-- MODAL -->
    <div
      class="modal fade"
      id="cancelar-lance-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="margin-top: 30px"
    >
      <form @submit.prevent>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
              <h4>Cancelar lances</h4>
              <br />
              <div class="form-group">
                <label for="leilao_acionar_regressiva_apos">Motivo do cancelamento</label>
                <textarea
                  id="justificativa"
                  name="justificativa"
                  class="form-control"
                  rows="4"
                  cols="50"
                  style="width: 100%"
                  v-model="formData.motivo_cancelamento"
                ></textarea>

                <span style="color: red" v-for="error in v$.motivo_cancelamento.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>

              <button class="btn btn-success" @click="cancelarLances()">Cancelar lance</button>
              <button style="margin-left: 5px" data-toggle="modal" id="cancelar" data-target="#cancelar-lance-modal" class="btn btn-danger">
                Fechar
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert.js";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../../mixins/auxController.js";
import currencyController from "../../controller/currencyController.js";
import Loading from "vue-loading-overlay";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";

import useVueLidate from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";
import { required } from "../../locales/i18n.js";
import { computed, reactive } from "vue";

import InputMask from "primevue/inputmask";

export default {
  props: ["estados"],

  mixins: [sweetAlert, Swal, AuxController, currencyController],

  components: [Loading, InputMask],

  setup() {
    const formData = reactive({
      motivo_cancelamento: "",
    });

    const rules = computed(() => {
      return {
        motivo_cancelamento: { required },
      };
    });

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  data() {
    return {
      isLoading: false,
      lance_selecionado: "",
      filtro: "",
      paginas: [],
      total: 0,
      inicio: 0,
      qtd_por_pagina: 25,
      pagina_atual: 1,
      lances: [],
      leilao_id: "",
      lote_id: "",
      praca: "",
      apelido: "",
      dataInicio: "",
      dataFim: "",
      motivo_cancelamento: "",
    };
  },

  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    let page = urlParams.get("page");

    if (page) {
      this.pagina_atual = Number(page);
    }

    this.buscarlances();
  },

  methods: {
    verificarResetarLances() {
      if (this.lances && this.lances.length && this.lances.length > 0) {
        let leilao_diferente = false;
        let primeiro_id = this.lances[0].id;

        for (let i = 0; i < this.lances.length; i++) {
          if (this.lances[0].id != primeiro_id) {
            leilao_diferente = true;
          }
        }

        if (leilao_diferente) {
          this.showErrorMessageWithButton("Leilões diferentes na lista de lances");
        } else {
          this.confirmarResetarLance();
        }
      }
    },

    confirmarResetarLance(lote) {
      this.$swal
        .fire({
          title: "Confirmação",
          html: "Deseja deletar todos os lances do leilão " + this.lances[0].leilao_id + "</b> ?</h3>",
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero alterar!",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              leilao_id: this.lances[0].leilao_id,
            };

            axios
              .post(`/admin/reset_lances/resetar`, data)
              .then((response) => {
                this.isLoading = false;
                this.showSuccessMessageWithButton("Sucesso", "Lances deletados");
                this.buscarlances();
              })
              .catch((error) => {
                this.showErrorMessageWithButton("Ops..", error);
                console.log(error);
              });
          } else {
            lote.status_temp = lote.lote_status;
          }
        });
    },

    limparFiltros() {
      this.leilao_id = "";
      this.lote_id = "";
      this.praca = "";
      this.apelido = "";
      this.dataInicio = null;
      this.dataFim = "";

      document.getElementById("data_inicio").value = "";
      document.getElementById("data_fim").value = "";

      this.buscarlances();
    },

    async cancelarLances() {
      const result = await this.v$.$validate();

      if (result) {
        this.isLoading = true;

        this.$swal
          .fire({
            title: "<h3 style='color:#616060'>Deseja cancelar <b>TODOS</b> os lances desse usuário NESSE lote DESSE leilão?",
            icon: "warning",
            padding: "1.5em",
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sim, quero cancelar!",
          })
          .then((result) => {
            if (result.value) {
              this.isLoading = true;

              let data = {
                id: this.lance_selecionado.lote_lance_user_id,
                leilao_id: this.lance_selecionado.leilao_id,
                lote_id: this.lance_selecionado.lote_id,
                praca: this.lance_selecionado.praca,
                user_id: this.lance_selecionado.lote_lance_user_id,
                motivo_cancelamento: this.formData.motivo_cancelamento,
              };

              console.log("Deletando ");
              console.log(data);

              axios
                .post(`/admin/lances/cancelar_lances`, data)
                .then((response) => {
                  this.showSuccessMessage("Lances deletados!");

                  this.buscarlances();

                  let btn = document.getElementById("cancelar");
                  btn.click();
                })
                .catch((error) => {
                  this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                  console.log(error.response.data);
                });
            }
          });
      }
    },

    getUrlEdit(processo) {
      return "/admin/processo/" + processo.id;
    },

    show(processo) {
      this.lance_selecionado = processo;
    },

    selecionarPagina(pagina) {
      if (pagina <= this.paginas[this.paginas.length - 1] && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        window.history.replaceState(null, null, "?page=" + pagina);

        this.buscarlances();
      } else if (pagina == this.max_page && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;

        window.history.replaceState(null, null, "?page=" + this.max_page);

        this.buscarlances();
      }
    },

    buscarlances() {
      this.isLoading = true;

      let data = {
        apelido: this.apelido,
        praca: this.praca,
        leilao_id: this.leilao_id,
        lote_id: this.lote_id,
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
      };

      if (this.dataInicio) {
        data.data_inicio = this.formatSelectedDate(this.dataInicio);
      }

      if (this.dataFim) {
        data.data_fim = this.formatDateToSearch(this.dataFim);
      }

      console.log("Buscando");
      console.log(data);

      axios
        .post(`/admin/lances/search_with_user_info_not_deleted  `, data)
        .then((response) => {
          this.lances = response.data.lances;
          this.total = response.data.total;

          this.pagination(response.data);
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    getFormatedTitle(title) {
      if (title && title.length > 28) {
        return title.substring(0, 28) + "...";
      } else {
        return title;
      }
    },

    formatSelectedDate(date) {
      return moment(date).format("yyyy-MM-DD");
    },

    formatDateToSearch(date) {
      return moment(date).format("yyyy-MM-DD 23:59:59");
    },

    buscarCidades() {
      this.isLoading = true;

      let data = {
        estado_id: this.estado.id,
      };

      axios
        .post(`/admin/endereco/cidades_por_estado`, data)
        .then((response) => {
          this.cidades = response.data.cidades;

          this.isLoading = false;
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      this.max_page = Math.ceil(length);

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          length = Math.ceil(length);

          if (length - this.pagina_atual >= 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }

          //CASO O CALCULO O MINIMO SEJA IGUAL A PAGINA ATUAL - 1, REDUZIR 10 DA PAGINA ATUAL CASO ELA SEJA MAIOR QUE 10
          if (i == this.pagina_atual - 1 && this.pagina_atual >= 10) {
            i = this.pagina_atual - 10;
          }

          console.log("I = " + i);
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.buscarlances();
    },

    deletar(processo) {
      this.lance_selecionado = processo;

      this.$swal
        .fire({
          title: "<h3 style='color:#616060'>Deseja deletar o tipo de processo<b><br/>" + this.lance_selecionado.nome + "</b>? </h3>",
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero deletar!",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              id: this.lance_selecionado.id,
            };

            axios
              .post(`/admin/processo/delete`, data)
              .then((response) => {
                this.showSuccessMessage("processo deletado!");

                window.location.reload();
              })
              .catch((error) => {
                this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                console.log(error.response.data);
              });
          }
        });
    },

    validateFields() {
      if (!this.nome) {
        this.showErrorMessageWithButton("Ops...", "O campo nome é obrigatório!");
      } else {
        this.create();
      }
    },

    update() {
      this.isLoading = true;

      let data = {
        id: this.lance_selecionado.id,
        cadastro_tipo: this.lance_selecionado.cadastro_tipo,
        tipodoc: this.lance_selecionado.tipodoc,
        estado_civil: this.lance_selecionado.estado_civil,
        obrigatorio: this.lance_selecionado.obrigatorio,
      };

      console.log("ATUALIZANDO");
      console.log(data);

      axios
        .post(`/admin/documento_tipo_usuario/update`, data)
        .then((response) => {
          this.showSuccessMessage("Estilo atualizado!");

          window.location.reload();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
  },
};
</script>
